import React from 'react';
import CurrencyInput, { CurrencyInputProps } from 'react-currency-input-field';
import { inputStyles } from './helpers';
import { clsxMerge } from '../../utils/classNameUtils';
import { getCurrencySymbol } from '../../utils/helper';
import { AlertCircleIcon } from '../icons';

interface InputProps extends CurrencyInputProps {
    label: string;
    infoText?: string;
    isError?: boolean;
    errorMessage?: string;
    onValueChange?: (val?: string) => void;
    currency?: string;
    leftIcon?: React.ReactNode;
    rightIcon?: React.ReactNode;
}

const CustomCurrencyInput = ({
    label,
    onValueChange,
    infoText,
    className,
    size,
    rightIcon,
    leftIcon,
    isError,
    errorMessage,
    disabled,
    value,
    currency,
    ...props
}: InputProps) => {
    return (
        <div>
            <label
                htmlFor='input-group-1'
                className='block mb-2 text-sm font-medium text-gray700 text-left'
            >
                {label}
            </label>

            <div className='relative'>
                <div className='absolute inset-y-0 start-0 flex items-center px-3.5 pointer-events-none'>
                    {Boolean(leftIcon) && leftIcon}
                </div>
                <CurrencyInput
                    id='currency-input'
                    name='currency'
                    placeholder='Enter amount'
                    decimalsLimit={2}
                    prefix={`${getCurrencySymbol(currency)} `}
                    value={value}
                    onValueChange={(value) => onValueChange?.(value || '')}
                    className={clsxMerge(
                        inputStyles({
                            variant: disabled
                                ? 'disabled'
                                : isError
                                ? 'error'
                                : 'default',
                            spacing: leftIcon ? 'left' : 'right'
                        }),
                        className
                    )}
                    {...props}
                />
                <div className='absolute inset-y-0 right-4 flex items-center ps-3.5 pointer-events-none'>
                    {isError ? (
                        <AlertCircleIcon />
                    ) : Boolean(rightIcon) ? (
                        rightIcon
                    ) : null}
                </div>
            </div>
            {Boolean(errorMessage) ? (
                <p className='text-xs text-red100'>{errorMessage}</p>
            ) : Boolean(infoText) ? (
                <p className='text-xs text-gray200'>{infoText}</p>
            ) : null}
        </div>
    );
};

export default CustomCurrencyInput;
